<template>
  <!-- 全局banner -->
  <div>
    <div class="banner">
      <div class="info-box">
        <div class="info-top">
          <!-- 标题 -->
          <h1 class="title">{{ noticeContent }}</h1>

          <!-- 用户登录状态 -->
          <div v-show="isShowContent('home') ? true : false" @click="toMyRecord">
            <span v-if="userInfo.isLogin" class="user-record">
              <img class="TV-icon" src="@/assets/images/assistant-agent/TV-icon.png" alt="TV-icon" />
              <span>我的申请记录</span>
            </span>
            <span v-else class="user-record" @click="toLogin">
              <img class="TV-icon" src="@/assets/images/assistant-agent/TV-icon.png" alt="TV-icon" />
              <span>登录后查看我的记录</span>
            </span>
          </div>
        </div>

        <span v-show="isShowContent('service') ? false : true" class="tips"
          >为群众和企业提供面对面服务，网上办理有人帮，<br />为特殊群体提供更多关怀服务</span
        >
      </div>

      <!-- 服务类型切换 -->
      <div v-show="isShowContent('service')" class="service-type-tag">
        <div class="service-btn-box">
          <div
            class="service-btn"
            :class="serviceType === 'personal' ? 'active-btn' : ''"
            @click="checkServiceType('personal')"
          >
            个人服务
          </div>
          <div
            class="service-btn"
            :class="serviceType === 'legalperson' ? 'active-btn' : ''"
            @click="checkServiceType('legalperson')"
          >
            法人服务
          </div>
        </div>
      </div>
    </div>

    <!-- 面包屑-在线预约相关路由展示 -->
    <div v-show="showBreadcrumb" class="breadcrumb">
      <div class="tag">
        首页 / <router-link to="/home" class="gray-link">帮代办专区</router-link> /
        <span class="blue-text">{{ pathMetaTitle }}</span>
      </div>
    </div>

    <!-- 页面右侧浮动-使用指引跳转按钮 -->
    <SearchFileButton
      v-show="
        currentPath !== '/upload-file-by-mobile' &&
        currentPath !== '/sign-view' &&
        currentPath !== '/guidelines-for-video'
      "
    />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { sm2Decrypt } from '@/utils/sm-crypto'
import { JaasWebApi } from '@/api/jaasweb'
import SearchFileButton from '@/components/global/SearchFileButton.vue' // 使用指引跳转按钮
import mixin from '@/mixin'
import tool from '@/utils/tool'

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Banner',
  components: {
    SearchFileButton
  },
  mixins: [mixin],
  data() {
    return {
      currentPath: '',
      serviceType: 'personal',
      isLogin: false,
      pathMetaTitle: '',
      noticeContent: ''
    }
  },
  computed: {
    // 根据路由判断是否展示面包屑
    showBreadcrumb() {
      const pathArr = ['/', '/service', '/home', '/guidelines-for-video']
      const currentPath = this.$route.path
      return !pathArr.includes(currentPath)
    },
    ...mapState(['userInfo'])
  },
  watch: {
    // 监听事项类型
    '$store.state.serviceType': {
      handler(newValue) {
        // 在这里可以执行一些逻辑，例如更新组件内部的数据
        this.serviceType = newValue
      },
      immediate: true // 立即执行一次
    },
    // 监听用户登录状态
    '$store.state.isLogin': {
      handler(newValue) {
        // 在这里可以执行一些逻辑，例如更新组件内部的数据
        this.isLogin = newValue
      },
      immediate: true // 立即执行一次
    }
  },
  beforeCreate() {
    // 使用 $router.afterEach 监听路由变化
    this.$router.afterEach((to) => {
      // 在路由变化后执行的操作
      if (this.$route.meta?.title) {
        const titleArr = this.$route.meta?.title.split('-')
        this.pathMetaTitle = titleArr[titleArr.length - 1]
      }
      this.currentPath = to.path
      // 存储区划信息
      if (this.getCookie('areaCodeCookie')) {
        const areaInfo = this.getCookie('areaCodeCookie')
        this.$store.commit('setAreaInfo', areaInfo)
      }
    })
  },
  created() {
    this.getConfig()
  },
  mounted() {
    this.serviceType = this.$store.state.serviceType
    // 模拟用户登录
    this.simulatedLogin()
  },
  methods: {
    ...tool,
    // 根据路由变化，判断展示的内容
    isShowContent(contentType) {
      return this.currentPath.includes(contentType)
    },

    // 选择服务类型
    checkServiceType(type) {
      this.serviceType = type
      this.$store.commit('checkServiceType', type)
    },

    // 模拟登录
    simulatedLogin() {
      console.log(process.env, 'process.env.BASE_URL')
      // this.setUserInfo()
      if (process.env.NODE_ENV === 'development') {
        // 创建用户信息
        const userInfo = {
          isLogin: true,
          encodeUser: {
            uid: '924519ae08204303a2832c0c2663b21b',
            userType: 1,
            name: '孙广财',
            mobile: '13382001211',
            certType: '居民身份证',
            certNo: '320123199909151717',
            corporationName: null,
            creditCode: null,
            corUserName: null,
            corUserCertType: '',
            corUserCertNo: null
          },
          desensitizeUser: {
            uid: '924519ae08204303a2832c0c2663b21b',
            userType: 1,
            name: '*广财',
            mobile: '133******11',
            certType: '居民身份证',
            certNo: '3****************7',
            corporationName: null,
            creditCode: null,
            corUserName: null,
            corUserCertType: null,
            corUserCertNo: null
          },
          accessToken:
            'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE3MTYyMDIwMjQsImlhdCI6MTcxNjE4NDAyNCwidXNlcm5hbWUiOiI5MjQ1MTlhZTA4MjA0MzAzYTI4MzJjMGMyNjYzYjIxYiJ9.5jd9u7xTTgNON2XQyUrM2rsJB4IW-FxJ494CTWKGof0'
        }
        // sessionStorage.setItem('JiopUserInfo', JSON.stringify(userInfo))
        const config = { userType: 1, appType: 1 }
        this.$store.commit('setConfig', config)
        this.$store.commit('setUserInfo', userInfo)
        this.$store.commit('setLoginState', userInfo.isLogin)
        document.cookie = `accessToken=${userInfo.accessToken}`
      } else {
        this.setUserInfo()
      }
    },

    // 获取用户信息并存储
    setUserInfo() {
      JaasWebApi.isLogin({ userType: 1, appType: 1 }).then((res) => {
        if (res.success) {
          if (res.data.isLogin) {
            const userInfo = res.data
            userInfo.encodeUser = JSON.parse(sm2Decrypt(userInfo.encodeUser))
            userInfo.desensitizeUser = JSON.parse(userInfo.desensitizeUser)
            const config = { userType: userInfo.desensitizeUser.userType, appType: 1 }
            this.$store.commit('setConfig', config)
            this.$store.commit('setUserInfo', userInfo)
            this.$store.commit('setLoginState', userInfo.isLogin)
          } else {
            this.$store.commit('setUserInfo', res.data)
          }
        }
      })
    },

    // 查看我的记录
    toMyRecord() {
      this.$router.push('/assistant-record')
    },

    // 获取指引文件
    getConfig() {
      JaasWebApi.findConfig({ type: 'jcpz' })
        .then((res) => {
          // 处理响应
          if (res.success) {
            console.log(res, '获取指引文件')
            this.noticeContent = res.data.baseConfig.noticeContent
          } else {
            this.noticeContent = '政务服务帮代办系统'
          }
        })
        .catch((err) => {
          // 处理错误
          this.noticeContent = '政务服务帮代办系统'
          console.log(err)
        })
    }
  }
}
</script>
<style lang="less" scoped>
.banner {
  background: url(@/assets/images/assistant-agent/banner.png) no-repeat center;
  height: 240px;
  // 宽度自适应
  width: 100%;
  background-size: cover;
  position: relative;

  .info-box {
    width: 1200px;
    margin: 0 auto;
    padding-top: 56px;

    .info-top {
      display: flex;
      justify-content: space-between;
      margin-bottom: 15px;

      .title {
        width: 500px;
        height: 56px;
        font-weight: 600;
        font-size: 40px;
        color: #ffffff;
        letter-spacing: 0;
      }

      .user-record {
        width: 229px;
        height: 50px;
        background-color: rgba(255, 255, 255, 0.4); /* 使用RGB表示白色，同时设置透明度为0.4 */
        border-radius: 8px;
        line-height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #ffffff;
        cursor: pointer;

        .TV-icon {
          width: 20px;
          height: 20px;
          margin-right: 8px;
        }
      }
    }

    .tips {
      width: 308px;
      height: 40px;
      opacity: 0.8;
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
      letter-spacing: 0;
    }
  }

  .service-type-tag {
    width: 100%;
    height: 70px;
    position: absolute;
    bottom: 0;

    .service-btn-box {
      width: 1200px;
      margin: 0 auto;

      .service-btn {
        width: 50%;
        height: 70px;
        background: rgba(255, 255, 255, 0.2);
        display: inline-flex;
        justify-content: center;
        align-items: center;
        font-size: 24px;
        color: #ffffff;
        cursor: pointer;
        font-weight: 500;
      }

      .active-btn {
        background: #ffffff;
        color: #1769fe;
      }
    }
  }
}

.breadcrumb {
  .tag {
    height: 52px;
    width: 1200px;
    margin: 0 auto;
    line-height: 52px;
    color: #999;

    .blue-text {
      color: #2078f3;
    }
  }
  .gray-link {
    color: #999; // 置灰颜色
    text-decoration: none; // 去掉下划线（可选）
  }
}
</style>
